import type { CompanyAnalytics } from "@/modules/companies/api/types"

import { useQuery } from "@tanstack/react-query"
import { useParams } from "next/navigation"

import {
  DEFAULT_QUERY_CACHE_TIME as QUERY_CACHE_TIME,
  DEFAULT_QUERY_STALE_TIME as QUERY_STALE_TIME,
} from "@/modules/api/constants"
import {
  COMPANY_ARTICLE_ANALYTICS_QUERY_KEY,
  getCompanyAnalytics,
} from "@/modules/companies/api/endpoints/companyAnalytics"
import { useCompanyFetch } from "@/modules/companies/hooks/useCompanyFetch"

type CompanyAnalyticsFetch = {
  dataCompanyAnalytics?: CompanyAnalytics
  isErrorCompanyAnalytics: boolean
  isLoadingCompanyAnalytics: boolean
  isSuccessCompanyAnalytics: boolean
}

export const useCompanyAnalyticsFetch = (): CompanyAnalyticsFetch => {
  const { dataCompany } = useCompanyFetch()
  const { companySlug } = useParams()

  const {
    data: dataCompanyAnalytics,
    isError: isErrorCompanyAnalytics,
    isPending: isLoadingCompanyAnalytics,
    isSuccess: isSuccessCompanyAnalytics,
  } = useQuery({
    enabled: !!dataCompany?.id,
    gcTime: QUERY_CACHE_TIME,
    queryFn: () =>
      getCompanyAnalytics({
        permalink: companySlug as string,
      }),
    queryKey: [COMPANY_ARTICLE_ANALYTICS_QUERY_KEY, companySlug],
    staleTime: QUERY_STALE_TIME,
  })

  return {
    dataCompanyAnalytics,
    isErrorCompanyAnalytics,
    isLoadingCompanyAnalytics,
    isSuccessCompanyAnalytics,
  }
}
